import { CompanyApi } from "../Api";
import { AcademicUserApi } from "../Api";

export const validateCompanyByMailToken = async (token: string) => {
	await new CompanyApi().apiCompanyValidateEmailTokenPost({ token });
};

export const validateExternalByMailToken = async (token: string) => {
	await new AcademicUserApi().apiAcademicUserValidateExternalEmailTokenPost({
		token,
	});
};
